import { render } from "./AddClient.vue?vue&type=template&id=1e7b40de&scoped=true"
import script from "./AddClient.vue?vue&type=script&lang=js"
export * from "./AddClient.vue?vue&type=script&lang=js"

import "./AddClient.vue?vue&type=style&index=0&id=1e7b40de&lang=scss"
import "./AddClient.vue?vue&type=style&index=1&id=1e7b40de&scoped=true&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7b40de"]])

export default __exports__